import { render, staticRenderFns } from "./BranchesManagement.vue?vue&type=template&id=51b4b087&scoped=true"
import script from "./BranchesManagement.vue?vue&type=script&lang=js"
export * from "./BranchesManagement.vue?vue&type=script&lang=js"
import style0 from "./BranchesManagement.vue?vue&type=style&index=0&id=51b4b087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4b087",
  null
  
)

export default component.exports